import { initializeIcons } from '@fluentui/react';

/**
 * Register the Fluent UI icon font exactly once.
 *
 * Fluent's `IconButton`/`Icon` render an EMPTY glyph when the icon set hasn't been registered —
 * the control is still present and clickable, it is just invisible. The only other caller in this
 * project is `CalendarBarComponent`, which never mounts on the FM Dashboard routes, so every FM
 * icon (month chevrons, Export, legend toggles) rendered blank.
 *
 * Guarded so repeated imports/mounts don't re-register (Fluent logs a duplicate-registration
 * warning); `disableWarnings` also keeps it quiet if the FXP shell already registered the set.
 */
let initialized = false;

export function ensureFluentIcons(): void {
  if (initialized) {
    return;
  }
  initialized = true;
  try {
    initializeIcons(undefined, { disableWarnings: true });
  } catch {
    // Icon registration is cosmetic — never let it break a render.
  }
}
